// ─────────────────────────────────────────────
// OpenEndedQuestion
//
// Textarea for free-text open-ended responses.
// Design: §6.5 Question Type → OPEN_ENDED
// ─────────────────────────────────────────────

import { useTranslation } from "@/hooks/useTranslation";

interface OpenEndedQuestionProps {
  questionId: string;
  value: string | null;
  onChange: (value: string) => void;
  readOnly?: boolean;
  placeholder?: string;
}

export function OpenEndedQuestion({
  questionId,
  value,
  onChange,
  readOnly,
  placeholder,
}: OpenEndedQuestionProps) {
  const { t } = useTranslation();
  const effectivePlaceholder = placeholder ?? t("assessment.review.enterResponse");
  return (
    <textarea
      id={questionId}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      readOnly={readOnly}
      placeholder={readOnly ? "" : effectivePlaceholder}
      rows={4}
      className="min-h-[100px] w-full rounded-control border border-border-default bg-bg-input px-3 py-2 text-[14px] text-text-primary placeholder:text-text-muted resize-y focus:outline-none focus:ring-1 focus:border-accent focus:ring-accent disabled:opacity-50 read-only:opacity-70 read-only:cursor-default"
    />
  );
}
